import { Platform } from "react-native";
import Back from "../../assets/back_white.svg";

function support() {
  if (Platform.OS === "ios" || Platform.OS === "android") {
    return true;
  } else {
    return false;
  }
}

const BackSVG = () => {
  if (support()) {
    return <Back width={25} height={25} fill={"white"} />;
  } else {
    return <img src={Back} width={25} height={25} />;
  }
};

export default BackSVG;
